module.exports = __webpack_public_path__ + "img/logo_footer.53e03363.svg";